export const ADMIN_AUTH_KEY = 'adminAuth';
export const ADMIN_AUTH_EXP_KEY = 'adminAuthExpires';
const ONE_HOUR_MS = 60 * 60 * 1000;

export function isAuthed(): boolean {
  try {
    if (localStorage.getItem(ADMIN_AUTH_KEY) !== 'true') return false;
    const expRaw = localStorage.getItem(ADMIN_AUTH_EXP_KEY);
    const exp = expRaw ? parseInt(expRaw, 10) : 0;
    if (!exp || Number.isNaN(exp) || Date.now() > exp) {
      // Süresi dolmuş, otomatik logout
      logout();
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function login(username: string, password: string): boolean {
  const u = (username ?? '').trim().toLocaleLowerCase();
  const p = (password ?? '').trim();
  const ok = u === 'admin' && p === 'g7R!v9Q#k2Zp@4Lm';
  if (ok) {
    localStorage.setItem(ADMIN_AUTH_KEY, 'true');
    const exp = Date.now() + ONE_HOUR_MS;
    localStorage.setItem(ADMIN_AUTH_EXP_KEY, String(exp));
    // Otomatik logout zamanlayıcı (yeniden yüklemede isAuthed yine kontrol eder)
    try {
      const remaining = Math.max(0, exp - Date.now());
      if (typeof window !== 'undefined') {
        window.setTimeout(() => {
          // Eğer oturum hala geçerliyse, süre dolduğunda çıkış yap
          if (localStorage.getItem(ADMIN_AUTH_KEY) === 'true') {
            const expCheck = parseInt(localStorage.getItem(ADMIN_AUTH_EXP_KEY) || '0', 10);
            if (Date.now() >= expCheck) logout();
          }
        }, remaining);
      }
    } catch {}
  }
  return ok;
}

export function logout() {
  try {
    localStorage.removeItem(ADMIN_AUTH_KEY);
    localStorage.removeItem(ADMIN_AUTH_EXP_KEY);
  } catch {}
}
